import React from 'react'
import { Container, Row, Col, Button } from "react-bootstrap"

const HeroSection = () => {
  return (
    <Container className= 'hero-section-container'>
        <Row className='n-100'>
            <Col
              xs="12"
              md="8" className='d-flex flex-column justify-content-center text-start px-4'>
             <div className='mx-4'>
                 <h1>photography Portfolio and My Project</h1>
                 <p>
                    I will be king, Just one day.ogogogogogo
                 </p>
             </div>
             <div className="btns-wrapper px-4 d-flex align-items-center">
                 <a href='/'>Read my blog</a>
                 <Button variant='secondary'>Learn More</Button>
             </div>
            </Col>
            <Col xs="12" md="4">
             <div className='img-wrapper'>{/*ここに背景画像のURLを入れる*/}</div>
            </Col>

        </Row>

    </Container>
  )
}

export default HeroSection